import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const BORDER = 'border-gray-200';

const SidebarSkeleton: FC = () => (
  <aside className="hidden xl:flex w-md shrink-0 flex-col gap-4 p-8">
    <SkeletonLoader className="h-7 w-40 rounded" />
    <div className="flex items-center gap-2">
      <SkeletonLoader.Text className="h-4 w-48" />
      <SkeletonLoader className="h-6 w-6 rounded ml-auto shrink-0" />
    </div>
    <div className="flex gap-2">
      <SkeletonLoader className="h-9 flex-1 rounded-lg" />
      <SkeletonLoader className="h-9 flex-1 rounded-lg" />
    </div>
    <div className="space-y-3">
      {Array.from({ length: 4 }).map((_, i) => (
        <div
          key={i}
          className={`border ${BORDER} rounded-lg p-3 flex flex-col gap-2`}
        >
          <SkeletonLoader.Text className="h-4 w-3/4" />
          <SkeletonLoader.Text className="h-3 w-1/2" />
        </div>
      ))}
    </div>
  </aside>
);

/** The two-row controls bar above the calendar. */
const ToolbarSkeleton: FC = () => (
  <div className="flex flex-col gap-3">
    <div className="flex items-center gap-2 flex-wrap">
      <SkeletonLoader className="h-8 w-16 rounded-full" />
      <SkeletonLoader className="h-9 w-40 rounded-lg ml-auto" />
      <SkeletonLoader className="h-9 w-32 rounded-lg" />
    </div>
    <div className="flex items-center gap-2 flex-wrap">
      <SkeletonLoader className="h-9 w-28 rounded-lg" />
      <SkeletonLoader className="h-9 w-20 rounded-lg" />
      <div className="flex items-center gap-2 mx-auto">
        <SkeletonLoader className="h-8 w-8 rounded-lg" />
        <SkeletonLoader className="h-5 w-40 rounded" />
        <SkeletonLoader className="h-8 w-8 rounded-lg" />
      </div>
      <SkeletonLoader className="h-9 w-28 rounded-lg" />
      <SkeletonLoader className="h-9 w-9 rounded-lg" />
      <SkeletonLoader className="h-9 w-9 rounded-lg" />
    </div>
  </div>
);

const SchedulePageSkeleton: FC = () => (
  <div className="flex w-full h-full bg-gray-50">
    <SidebarSkeleton />

    <div className="flex grow flex-col gap-4 p-8 bg-white min-w-0">
      <ToolbarSkeleton />
      {/* A single surface for whichever view loads (calendar or map). */}
      <SkeletonLoader className="flex-1 min-h-0 rounded-lg" />
    </div>
  </div>
);

export default SchedulePageSkeleton;
